import gql from 'graphql-tag';

export const EXPORT_EMAILS = gql`
    mutation ExportEmails{
        ExportEmails
    }
`;
